<template>
  <div class="equipmentCapacityMaintenance">
    <m-assembly-table
      ref="searchForm"
      :formData="block.formData"
      :columns="block.tableColumns"
      :data="block.tableData"
      :currentPage="block.settings.currentPage"
      :pageSize="block.settings.pageSize"
      :settings="block.settings"
      :tableButtons="block.tableButtons"
      :tableTitle="block.tableTitle"
      :loading="block.loading"
      :total="block.settings.total"
      @onSubmit="onSubmit"
      @onPageSizeChange="onPageSizeChange"
      @onCurrentPageChange="onPageChange"
      @resetData="resetData"
    >
    </m-assembly-table>
    <m-import
      ref="import"
      :upLoadUrl="iModal.upLoadUrl"
      :title="iModal.title"
      :showSuccessDeal="true"
      @successDeal="successDeal"
      @downLoadResult="downLoadResult"
      @downloadTemplate="downloadTemplate"
      @iModalClose="iModalClose"
      @complete="complete"
    ></m-import>
  </div>
</template>

<script>
import mAssemblyTable from "@/components/awesome/page/assembly_table/index.js";
import createEle from "@/utils/createEle";
import axios from "axios";
import mImport from "@/components/import";

export default {
  name: "equipmentCapacityMaintenance", // 设备产能维护
  components: {
    mAssemblyTable,
    mImport,
  },
  data() {
    return {
      supplierInfo: {},
      initParams: {},
      organizationCode: "",
      openVendoeParams: {},
      invList: [],
      initTableRow: {},
      selectedData: [],
      iModal: {
        upLoadUrl: "/srmquo/equipmentCapacityGsc/importData",
        title: this.$t("equipmentCapacityMaintenance.excelImport"), // '导入',
      },
      block: {
        condition: null,
        tableTitle: "",
        loading: false,
        tableButtons: {
          systemButtons: [],
          customButtons: [
            {
              name: "",
              label: this.$t("equipmentCapacityMaintenance.add"), //新增
              type: "primary",
              loading: false,
              disabled: false,
              click: () => {
                this.block.tableData.unshift({
                  tempIndex: Date.now(),
                  ...this.initTableRow,
                });
              },
            },
            {
              name: "",
              label: this.$t("equipmentCapacityMaintenance.excelImport"),
              type: "primary",
              loading: false,
              disabled: false,
              click: () => {
                this.$refs.import.show = true;
              },
            },
            {
              name: "",
              label: this.$t("equipmentCapacityMaintenance.edit"),
              type: "primary",
              loading: false,
              disabled: false,
              click: this.handleEdit,
            },
            {
              name: "",
              label: this.$t("equipmentCapacityMaintenance.save"),
              type: "primary",
              loading: false,
              disabled: false,
              click: this.handleSave,
            },
          ],
        },
        settings: {
          leftSpan: 20,
          needPager: true,
          showElevator: false,
          showSizer: true,
          pageSizeOpts: [10, 30, 50, 80],
          needTable: true,
          needSearch: true,
          needValidation: true,
          currentPage: 1,
          pageSize: 10,
          total: 0,
        },
        tableData: [],
        tableColumns: {
          columns: [
            {
              type: "selection",
              key: "selection",
              width: 50,
              align: "center",
              fixed: "left",
            },
            {
              title: this.$t("equipmentCapacityMaintenance.organizationCode"), //库存组织
              key: "organizationCode",
              align: "center",
              minWidth: 180,
              tooltip: true,
              renderHeader: (h, params) => createEle.span(h, params),
              render: (h, params) => this.createSelEleMethods(h, params),
            },
            {
              title: this.$t("equipmentCapacityMaintenance.mouldTon"), //设备吨位/T
              key: "mouldTon",
              align: "center",
              minWidth: 110,
              tooltip: true,
              renderHeader: (h, params) => createEle.span(h, params),
              render: (h, params) => this.createInputNumberEleMethods(h, params),
            },
            {
                title: this.$t('enameledWireMateBarView.t46'), // 模具类型
                key: 'mouldType',
                align: 'center',
                minWidth: 110,
                renderHeader: (h, params) => createEle.span(h, params),
                render: (h, params) => {
                    if (params.row._isAdd || params.row._isEdit) {
                        const options = this.MODEL_TYPE.map((item) => {
                            return h('Option', {
                                props: {
                                    value: item.value,
                                    label: item.label,
                                },
                            });
                        });
                        return h('Select', {
                            props: {
                                value: params.row.mouldType,
                                size: 'small',
                            },
                            on: {
                                'on-change': (val) => {
                                    params.row.mouldType = val;
                                    this.block.tableData[params.index] = params.row;
                                },
                            }
                        }, options);
                    } else {
                        return h('span', this.MODEL_TYPE.find((item) => item.value === params.row.mouldType)?.label);
                    }
                },
            },
            {
              title: this.$t("equipmentCapacityMaintenance.mideaQuantity"), //给美的机台数量
              key: "mideaQuantity",
              align: "center",
              minWidth: 130,
              tooltip: true,
              renderHeader: (h, params) => createEle.span(h, params),
              render: (h, params) => this.createInputNumberEleMethods(h, params),
            },
            {
              title: this.$t("equipmentCapacityMaintenance.creationDate"), //创建日期
              key: "creationDate",
              align: "center",
              minWidth: 140,
              tooltip: true,
            },
            {
              title: this.$t("equipmentCapacityMaintenance.lastUpdateDate"), //更新日期
              key: "lastUpdateDate",
              align: "center",
              minWidth: 140,
              tooltip: true,
            },
            {
              title: this.$t("equipmentCapacityMaintenance.operate"), //操作
              key: "operate",
              align: "center",
              width: 120,
              fixed: "right",
              render: (h, params) => {
                return createEle.link(h, params, {
                  text: this.$t("equipmentCapacityMaintenance.del"), //删除
                  click: () => {
                    this.$Modal.confirm({
                      title: this.$t("equipmentCapacityMaintenance.warn"),
                      content: this.$t("equipmentCapacityMaintenance.sureDel"), //确定删除？
                      onOk: () => {
                        const id = params.row.equipmentCapacityId;
                        if (id) {
                          axios
                            .post("/srmquo/equipmentCapacityGsc/deleteByIds", [id])
                            .then((res) => {
                              const resp = res.data.data;
                              console.log("删除+++++++++++++res", resp);
                              if (resp.status === 0) {
                                this.$Modal.success({
                                  content: this.$t("equipmentCapacityMaintenance.delSuccess"), //删除成功
                                  duration: 1.5,
                                });
                                this.queryData();
                              } else {
                                this.$Modal.error({
                                  title: this.$t("equipmentCapacityMaintenance.warn"),
                                  content: resp.msg,
                                });
                              }
                            })
                            .catch(() => {
                              this.$Modal.error({
                                title: this.$t("equipmentCapacityMaintenance.warn"),
                                content: this.$t("common.error1"),
                              });
                            });
                        } else {
                          // 如果是新增的数据，前端直接删除
                          console.log("params++++++++", params);
                          this.block.tableData.splice(params.index, 1);
                        }
                      },
                    });
                  },
                });
              },
            },
          ],
        },
        formData: {
          labelWidth: 90,
          row: 1,
          items: [
            {
              value: "",
              field: "organizationCode",
              layout: {
                span: 8,
                offset: 0,
                row: 1,
              },
              filterable: true,
              methods: {},
              options: {
                clearable: true,
                values: [],
              },
              type: "select",
              title: this.$t("equipmentCapacityMaintenance.organizationCode"), // '库存组织',
              placeholder: this.$t("equipmentCapacityMaintenance.pleaseSelOrganizationCode"), //请选择库存组织
              labelWidth: 74,
            },
            {
              value: "",
              field: "mouldTonStart",
              layout: {
                row: 1,
                span: 8,
                offset: 0,
              },
              style: "width:100%",
              options: {
                // max: 100,
                min: 0,
                rows: 1,
              },
              type: "text",
              title: this.$t("equipmentCapacityMaintenance.mouldTon"),
              placeholder: "",
              isDouble: true,
              blur: (curObj) => {
                this.blurValidateNumber(curObj);
              },
            },
            {
              hide: true,
              value: "",
              field: "mouldTonEnd",
              layout: {
                span: 4,
                offset: 0,
                row: 1,
              },
              options: {
                // max: 100,
                min: 0,
                rows: 1,
              },
              style: "width:100%",
              type: "text",
              title: "",
              placeholder: "",
              blur(value) {
                // this.blurValidateNumber()
              },
            },
            {
              value: "",
              field: "creationDateStart",
              validators: {
                required: {
                  required: false,
                  message: "",
                },
              },
              layout: {
                row: 1,
                span: 8,
                offset: 0,
              },
              options: {
                type: "date",
                format: "yyyy-MM-dd",
              },
              style: "width:100%",
              type: "datePicker",
              title: this.$t("equipmentCapacityMaintenance.creationTime"), //创建时间
              isDouble: true,
              placeholder: this.$t("equipmentCapacityMaintenance.startTime"), //起始时间
            },
            {
              hide: true,
              value: "",
              field: "creationDateEnd",
              validators: {
                required: {
                  required: false,
                  message: "",
                },
              },
              layout: {
                span: 4,
                offset: 0,
                row: 1,
              },
              options: {
                type: "date",
                format: "yyyy-MM-dd",
                options: {
                  disabledDate(date) {},
                },
              },
              style: "width:100%",
              type: "datePicker",
              title: "",
              placeholder: this.$t("equipmentCapacityMaintenance.endTime"), //结束时间
            },
            {
              value: "",
              field: "lastUpdateDateStart",
              validators: {
                required: {
                  required: false,
                  message: "",
                },
              },
              layout: {
                row: 1,
                span: 8,
                offset: 0,
              },
              options: {
                type: "date",
                format: "yyyy-MM-dd",
              },
              style: "width:100%",
              type: "datePicker",
              title: this.$t("equipmentCapacityMaintenance.updateTime"), //更新时间
              placeholder: this.$t("equipmentCapacityMaintenance.startTime"), //起始时间
              isDouble: true,
              labelWidth: 74,
            },
            {
              hide: true,
              value: "",
              field: "lastUpdateDateEnd",
              validators: {
                required: {
                  required: false,
                  message: "",
                },
              },
              layout: {
                span: 4,
                offset: 0,
                row: 1,
              },
              options: {
                type: "date",
                format: "yyyy-MM-dd",
                options: {
                  disabledDate(date) {},
                },
              },
              style: "width:100%",
              type: "datePicker",
              title: "",
              placeholder: this.$t("equipmentCapacityMaintenance.endTime"), //结束时间
            },
          ],
        },
      },
      MODEL_TYPE: [],
    };
  },
  created() {
    this.supplierInfo = JSON.parse(localStorage.getItem("supplierInfo"));
    this.setInitTableRow();
    this.getInv(); // 获取库存组织
  },
  methods: {
    createInputNumberEleMethods(h, params) {
      let inputNumber = createEle.inputNumber(h, params, {
        placeholder: "请输入" + params.column.title,
        tableData: this.block.tableData,
        min: 0,
        change: (val) => {
          // this.$set(params.row, "inventoryOrgCode", params.row.inventoryOrgCodeList.join(";") || "");
        },
      });
      if (params.row._isAdd || params.row._isEdit) {
        return inputNumber;
      } else {
        return h("span", params.row[params.column.key]);
      }
    },
    createSelEleMethods(h, params) {
      const key = params.column.key;
      const optionsList = key === "organizationCode" ? this.invList : [];
      let select = createEle.select(h, params, {
        placeholder: this.$t("equipmentCapacityMaintenance.pleaseInput") + params.column.title, //请输入...
        tableData: this.block.tableData,
        options: optionsList,
        clearable: true,
        change: (val) => {
          if (key === "organizationCode") {
            if (val) {
              const orgName = this.invList.find((v) => v.value === val)?.label;
              this.$set(params.row, "organizationName", orgName);
            } else {
              this.$set(params.row, "organizationCode", "");
              this.$set(params.row, "organizationName", "");
            }
          }
        },
      });
      if (params.row._isAdd || params.row._isEdit) {
        return select;
      } else {
        const value=this.matchDictLabel(this.invList,params.row[key])
        return h("span", value);
      }
    },
    matchDictLabel(dict,value){
        if(!value){
            return ''
        }else{
            return dict.find(v=>v.value===value)?.label || ''
        }
    },
    isNumeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    blurValidateNumber(curObj) {
      const val = curObj.value;
      if (!val) return;
      if (!this.isNumeric(val) || val * 1 < 0) {
        this.$set(curObj, "value", 0);
        this.$Message.warning(this.$t("equipmentCapacityMaintenance.mouldTonPleaseInputPositiveNumbers")); //设备吨位请输入正数
      } else {
        this.validateMouldTon();
      }
    },
    validateMouldTon() {
      const mouldTonStart = this.getFormDataVal("mouldTonStart");
      const mouldTonEnd = this.getFormDataVal("mouldTonEnd");
      if (mouldTonStart && mouldTonEnd && mouldTonStart * 1 > mouldTonEnd * 1) {
        this.$Message.warning(this.$t("equipmentCapacityMaintenance.mouldTonBetween")); //设备吨位结束区间应大于起始区间！
        return;
      }
    },
    getInv() {
      this.getSRMInvLovListNew((data) => {
        this.invList =
          data?.map((v) => ({
            value: v.organizationCode,
            label: v.organizationName,
          })) || [];
        this.setOptionList(this.invList, "organizationCode");
      });
    },
    setOptionList(list, field) {
      this.block.formData.items.forEach((item, k) => {
        if (item.field === field) {
          this.$set(item.options, "values", list);
        }
      });
    },
    getFormDataVal(field) {
      return this.block.formData.items.find((item) => item.field === field).value;
    },
    setInitTableRow() {
      const userInfo = JSON.parse(localStorage.getItem("user"));
      this.initTableRow = this.block.tableColumns.columns.reduce((res, item) => {
        if (!["operate", "selection"].includes(item.key)) {
          res[item.key] = "";
        }
        return {
          ...res,
          _isAdd: true,
          _isEdit: false,
          _checked: true,
        };
      }, {});
      this.initParams = this.block.formData.items.reduce((res, curItem) => {
        res[curItem.field] = curItem.value;
        return res;
      }, {});
    },
    validateForm() {
      // 获取表格要校验的必填列字段
      const requiredColumns = ["organizationCode", "mouldTon", "mideaQuantity", 'mouldType'];
      const validateColumns = this.block.tableColumns.columns.reduce((res, curItem) => {
        if (requiredColumns.includes(curItem.key)) {
          res.push({
            key: curItem.key,
            title: curItem.title,
          });
        }
        return res;
      }, []);
      let requiredTips = [];
      for (let i = 0; i < this.selectedData.length; i++) {
        const item = this.selectedData[i];
        for (let j = 0; j < validateColumns.length; j++) {
          const v = validateColumns[j];
          if (!item[v.key]) {
            !requiredTips.includes(v.title) && requiredTips.push(v.title);
          }
          if (requiredTips.length === validateColumns.length) {
            break;
          }
        }
        if (requiredTips.length === validateColumns.length) {
          break;
        }
      }
      if (requiredTips.length) {
        const requiredRes = requiredTips.length
          ? requiredTips.join("；") + this.$t("equipmentCapacityMaintenance.cantNull") //...不能为空
          : "";
        this.$Modal.error({
          content: requiredRes,
        });
        return false;
      }
      return true;
    },
    setLoadingBtn(label, flag) {
      this.block.tableButtons.customButtons.forEach((v) => {
        if (v.label === label) {
          this.$set(v, "loading", flag);
        }
      });
    },
    handleSave() {
      // 勾选后再编辑不更新问题-重新赋值
      this.selectedData = this.$refs["searchForm"].getSelection();
      this.selectedData.forEach((v) => {
        delete v._isAdd;
        delete v._isEdit;
        delete v._checked;
      });
      if (!this.validateForm()) {
        return;
      }
      let url = "/srmquo/equipmentCapacityGsc/saveOrUpdate";
      this.setLoadingBtn(this.$t("equipmentCapacityMaintenance.save"), true);
      //发起更新数据请求
      axios
        .post(url, this.selectedData)
        .then((res) => {
          const resp = res.data.data;
          console.log("res++++++++++++++保存", resp);
          this.setLoadingBtn(this.$t("equipmentCapacityMaintenance.save"), false);
          if (resp.status === 0) {
            this.$Message.success(this.$t('equipmentCapacityMaintenance.saveSuccess'));
            this.queryData();
          } else {
            this.$Modal.error({
              title: this.$t("equipmentCapacityMaintenance.warn"),
              content: resp.msg,
            });
          }
        })
        .catch(() => {
          this.setLoadingBtn(this.$t("equipmentCapacityMaintenance.save"), false);
          this.$Modal.error({
            title: this.$t("equipmentCapacityMaintenance.warn"),
            content: this.$t("common.error1"),
          });
        });
    },
    handleEdit() {
      const selection = this.$refs.searchForm.getSelection();
      if (selection?.length) {
        const tableData = this.block.tableData;
        const selectionIds = selection.map((k) => k.equipmentCapacityId);
        tableData.forEach((v) => {
          if (selectionIds.includes(v.equipmentCapacityId)) {
            this.$set(v, "_isEdit", true);
            this.$set(v, "_checked", true);
          }
        });
      } else {
        this.$Message.warning(this.$t("equipmentCapacityMaintenance.pleaseSelectData"));
      }
    },
    validateDateBetween() {
      const { lastUpdateDateStart, lastUpdateDateEnd, creationDateStart, creationDateEnd } = this.block.condition;
      const flag1 = lastUpdateDateStart && lastUpdateDateEnd && new Date(lastUpdateDateStart).getTime() > new Date(lastUpdateDateEnd).getTime();
      const flag2 = creationDateStart && creationDateEnd && new Date(lastUpdateDateStart).getTime() > new Date(creationDateEnd).getTime();
      let warnTips = [];
      flag1 && warnTips.push(this.$t("equipmentCapacityMaintenance.lastUpdateTime"));
      flag2 && warnTips.push(this.$t("equipmentCapacityMaintenance.creationTime"));
      if (warnTips?.length) {
        this.$Message.warning(warnTips.join("/") + this.$t("equipmentCapacityMaintenance.endTimeMustQStart")); //"结束时间必须大于开始时间!"
        return;
      }
    },
    queryData() {
      this.block.condition = this.block.condition || this.initParams;
      this.validateMouldTon();
      this.validateDateBetween();
      const params = {
        ...this.block.condition,
        vendorCode: this.supplierInfo.vendorCode,
        vendorName: this.supplierInfo.vendorName,
        pageNum: this.block.settings.currentPage,
        pageSize: this.block.settings.pageSize,
      };
      console.log("params++++++++++", params);
      let url = "/srmquo/equipmentCapacityGsc/queryList";
      this.block.loading = true;
      axios
        .post(url, params)
        .then((res) => {
          this.block.loading = false;
          let resp = res.data.data;
          if (resp.status === 0) {
            this.block.tableData =
              resp?.data?.list?.map((v) => ({
                ...v,
                mouldType: this.MODEL_TYPE.find((dict) => dict.value === v.mouldType || dict.label === v.mouldType)?.value || '',
                _isAdd: false,
                _isEdit: false,
                _checked: false,
              })) || [];
            this.block.settings.total = resp.data.total || 0;
          } else {
            this.$Modal.error({
              title: this.$t("equipmentCapacityMaintenance.requestFail"), //请求失败
              content: res.data.msg,
            });
          }
        })
        .catch(() => {
          this.block.loading = false;
          this.$Modal.error({
            title: this.$t("equipmentCapacityMaintenance.warn"),
            content: this.$t("common.error1"),
          });
        });
    },
    getQueryInfo() {
      let params = {};
      this.formData.items.forEach((item) => {
        if (item.field === "inventoryCategoryList") {
          params.inventoryCategory = item.value.join(";");
        } else {
          params[item.field] = item.value;
        }
      });
      return params;
    },
    onSubmit(current, pageSize, condition) {
      console.log("condition+++++++", condition);
      this.block.condition = condition;
      this.block.settings.currentPage = 1;
      this.block.settings.pageSize = pageSize;
      this.queryData();
    },
    onPageChange(currentPage) {
      this.block.settings.currentPage = currentPage;
      this.queryData();
    },
    onPageSizeChange(currentPage, pageSize) {
      this.block.settings.currentPage = 1;
      this.block.settings.pageSize = pageSize;
      this.queryData();
    },
    resetData() {
      this.block.condition = this.initParams;
      this.queryData();
    },
    // 下载模板
    downloadTemplate() {
      window.open("/srmquo/equipmentCapacityGsc/exportMould");
    },
    //导入窗口关闭
    iModalClose() {
      this.$refs.import.show = false;
    },
    //导入窗口完成
    complete() {
      this.$refs.import.show = false;
    },
    // 模板下载成功
    downLoadResult(result) {
      const { docId } = result.sourceToken;
      // 模板下载通用接口
      docId && window.open(`/srmbase/supplierfile/downloadFile?docId=${docId}`);
    },
    successDeal(res, file) {
      if (res.data.data.status === "fail") {
        this.$Modal.error({
          content: res?.data?.data?.message || res.data?.msg,
        });
      } else {
        this.$Modal.success({ content: this.$t("UIDLabelPrint.t39") });
        this.$refs.import.show = false;
        this.queryData();
      }
    },
    getDictByCode(dictionaryCode) {
        axios.post('/srmbase/basicConfig/queryDictionaryType', {
            dictionaryCode,
        })
            .then((res) => {
                this[dictionaryCode] = res.data.data?.data || [];
            });
    },
  },
    mounted() {
        this.getDictByCode('MODEL_TYPE');
    },
};
</script>

<style scoped></style>
